import { estimatedMinutesError } from '../general/estimated-minutes';

export function EstimatedDuration({ minutes }: { minutes?: number | null }) {
    if (minutes == null || estimatedMinutesError(minutes)) return null;
    return <span className="text-sm text-color-secondary inline-flex align-items-center gap-2">
        <i className="pi pi-clock" aria-hidden="true" />Estimated time: {minutes} min
    </span>;
}
